import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
  Container,
} from '@mui/material';
import {
  Cancel as CancelIcon,
  ArrowBack as BackIcon,
  Home as HomeIcon,
  Refresh as RetryIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PaymentCancelled: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoToSubscriptions = () => {
    navigate('/subscriptions');
  };

  const handleRetryPayment = () => {
    navigate('/subscriptions');
  };

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <CircularProgress size={60} sx={{ mb: 3 }} />
        <Typography variant="h6" color="text.secondary">
          Processing...
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CancelIcon 
            sx={{ 
              fontSize: 80, 
              color: 'warning.main', 
              mb: 3 
            }} 
          />
          
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: 'warning.main' }}>
            Payment Cancelled
          </Typography>
          
          <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
            Your payment was not completed
          </Typography>
          
          <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              No charges have been made to your account. You can try again anytime.
            </Typography>
          </Alert>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
              What you can do:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Try the payment again<br/>
              • Choose a different subscription plan<br/>
              • Contact support if you need assistance
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<RetryIcon />}
              onClick={handleRetryPayment}
              size="large"
            >
              Try Again
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              size="large"
            >
              Go to Dashboard
            </Button>
            <Button
              variant="text"
              color="primary"
              startIcon={<BackIcon />}
              onClick={handleGoToSubscriptions}
              size="large"
            >
              View Plans
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PaymentCancelled;
